<template>
    <div class="vehicleQueue-box">
        <HeaderNav
            header-title="车辆排队"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="warpper" v-if="driverQueue.length>0">
            <div class="tag-box">
                <div class="top">
                    <span class="iconfont icontongzhi"></span>
                    <span v-if="currentIndex===0">
                        暂无您的排队信息！
                    </span>
                    <span
                        v-else-if="currentIndex===1"
                    >
                        您当前排在第<span class="red">{{ currentIndex }}</span>位，即将派单！
                    </span>
                    <span
                        v-else
                    >
                        您当前排在第<span class="red">{{ currentIndex }}</span>位，预计<span class="red">{{ waitTime }}</span>分钟后派单！
                    </span>
                </div>
                <!-- <div class="top current">
                    <span class="iconfont icontongzhi"></span>
                    <span>即将接单，请返回任务单界面，准备接单！</span>
                    <span class="iconfont iconxiangyou"></span>
                </div> -->
                <div class="bottom">
                    <div class="arrow-icon">
                        1
                    </div>
                    <img src="@/assets/images/home_sj/tanker.png">
                    <span class="tanker-num">{{ firstDriver.plate_number }}({{ firstDriver.plate_small_number }})</span>
                    <span class="wait-btn">等待</span>
                </div>
            </div>
            <div class="car-list">
                <template v-for="(item, index) in driverQueueD">
                    <div class="car-item" :key="index" :class="{'current-car': item.driver_phone===currentDriver.driver_phone}">
                        <span class="arrow-icon" v-if="item.driver_phone===currentDriver.driver_phone">本车</span>
                        <span class="arrow-icon arrow-icon-blue" v-else-if="index<currentIndex-1">{{ index+2 }}</span>
                        <span class="arrow-icon" v-else>{{ index+2 }}</span>
                        <div class="small-number">
                            {{ item.plate_small_number }}
                        </div>
                        <div><img src="@/assets/images/home_sj/tanker.png"></div>
                        <div class="car-num">
                            {{ item.plate_number }}
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="warpper no-data" v-else></div>
    </div>
</template>
<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
import { eventBus } from '@/common/eventBus.ts';
export default {
    components: {
        HeaderNav,
    },
    data() {
        return {
            StationId: '',
            MobilePhone: '',
            pagetion: {
                pageindex: 1,
                pagesize: 20,
            },
            driverQueue: [],
            currentDriver: {},
            currentIndex: 0,
            waitTime: 0, // 等待时间
            firstDriver: {},
            driverQueueD: [],
        };
    },
    methods: {
        // 获取司机相关排车列表（分页）
        getDriver() {
            this.MobilePhone = this.$takeTokenParameters('MobilePhone');
            this.$axios
                .get('/interfaceApi/production/vehicleinfo/get_driver_queue?phone=' + this.MobilePhone)
                .then(res => {
                    if (res) {
                        this.driverQueue = res;
                        res.map((item, index) => {
                            if (item.driver_phone === this.MobilePhone) {
                                this.currentDriver = item;
                                this.currentIndex = index + 1;
                                this.waitTime = index * 12;
                            }
                            if (index === 0) {
                                this.firstDriver = item;
                            }
                        });
                        const driverQueueD = JSON.parse(JSON.stringify(res));
                        driverQueueD.shift();
                        this.driverQueueD = driverQueueD;
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
    },
    mounted() {
        this.getDriver();
        // 添加事件总线eventBus
        eventBus.$on('vehicleQueuePush', () => {
            this.getDriver();
        });
        eventBus.$on('toCarOrder', () => {
            this.$router.push({ name: 'workOrder' });
        });
    },
    beforeDestroy() {
        // 清除事件总线eventBus
        eventBus.$off('vehicleQueuePush');
        eventBus.$off('toCarOrder');
    },
};
</script>

<style lang="stylus">
.vehicleQueue-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    .warpper
        font-size 14rpx
        padding 15rpx
        height 100%
        .tag-box
            width 100%
            height 92rpx
            border 1px solid rgba(240, 240, 240, 1)
            box-shadow 0px 1px 3px 0px rgba(240, 240, 240, 0.35)
            .top
                height 41rpx
                border-bottom  1px dashed #D7D7D7
                padding 0 15rpx
                line-height 40rpx
                .icontongzhi
                    font-size 15rpx
                    color #D6010F
                    margin-right 10rpx
                .red
                    color #D6010F
                &.current
                    background #E60000
                    color #fff
                    border-bottom none
                    margin-bottom 2rpx
                    .icontongzhi
                        color #ffffff
                    .iconxiangyou
                        margin-top 15rpx
                        font-size 16rpx
            .bottom
                position relative
                padding 12rpx 18rpx
                display flex
                justify-content: center;
                align-items: center;
                line-height: normal;
                .arrow-icon
                    background #FF6600
                    position absolute
                    left 0
                    top 0
                    color #fff
                    font-size 10.6px
                    line-height 16px
                    padding 0 0 0 5rpx
                    font-family: Helvetica Neue, Helvetica, -apple-system, Arial, sans-serif;
                    &:after
                        content ' '
                        width 7.5rpx
                        height 16px
                        display inline-block
                        background url(./../../../assets/images/home_sj/fillet_orange.png) no-repeat
                        background-size 100% 100%
                        position absolute
                        right -6.5rpx
                        top 0
                img
                    width 30rpx
                    height 30rpx
                    margin-right 10rpx
                .wait-btn
                    width 34rpx
                    border 1px solid rgba(255,102,0,1)
                    display inline-block
                    font-size: 10.6px;
                    color #FF6600
                    height 20rpx
                    line-height 20rpx
                    text-align center
                    margin 2rpx 0 0 10rpx
                .tanker-num
                    line-height 24rpx
                    font-size 16rpx
        .car-list
            overflow-x hidden
            overflow-y auto
            height calc(100% - 92rpx)
            .car-item
                border 1px solid #ddd
                height 100rpx
                box-sizing border-box
                margin-top 15rpx
                box-shadow 0px 1px 6px 0px rgba(240, 240, 240, 0.35)
                position relative
                text-align center
                margin-right 3%
                width calc((100% - 6%) / 3)
                float left
                .arrow-icon
                    background #D5D5D5
                    position absolute
                    left 0
                    top 0
                    color #fff
                    font-size 12rpx
                    text-align  left
                    padding 0 0 0 5rpx
                    height 15rpx
                    line-height 15rpx
                    &:after
                        content ' '
                        width 7.5rpx
                        height 15rpx
                        display inline-block
                        background url(./../../../assets/images/home_sj/fillet_gray.png) no-repeat
                        background-size 100% 100%
                        position absolute
                        right -6.5rpx
                        top 0
                    &.arrow-icon-blue
                        background #3495FB
                        &:after
                            background url(./../../../assets/images/home_sj/fillet_blue.png) no-repeat
                            background-size 100% 100%
                img
                    width 58rpx
                    height 28rpx
                    margin-top 6rpx
                .small-number
                    margin-top 6rpx
                    color #3495FB
                .car-num
                    position absolute
                    bottom 0
                    left 0
                    width 100%
                    height 30rpx
                    background #FAFAFA
                    text-align center
                    line-height 30rpx
                &:nth-child(3n)
                    margin-right 0
                &.current-car
                    border 1px solid #17BC84
                    .arrow-icon
                        background #17BC84
                        &:after
                            background url(./../../../assets/images/home_sj/fillet_green.png) no-repeat
                            background-size 100% 100%
                    .car-num
                        background #17BC84
                        color #fff
                    .small-number
                        color #17BC84
</style>
